// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__tPXtq","productName":"Table_productName__W3tqT"};